module.exports = __webpack_public_path__ + "img/sub-nav-sidebar-toggle.db01b6d8.svg";